import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=1458acd9&"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts&"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports